import { Filters } from '$/repositories/supabaseRepository/SupabaseRepository.ts';

export function filtersToStringArray<T>(filters?: Filters<T>): string[] {
  if (!filters) {
    return [];
  }

  return Object.entries(filters)
    .map(([key, param]: [any, any]) => {
      if (param?.comparator) {
        return `${key}_${param.value}`;
      }

      return `${key}_${param}`;
    })
    .filter((param) => param !== null && param !== undefined) as string[];
}
